/** Super-admin roles must use the admin portal, not the end-user flow. */
export const SUPER_ADMIN_ROLES = [
  "PRIMARY_SUPER_ADMIN",
  "SECONDARY_SUPER_ADMIN"
] as const;

export type SuperAdminRole = (typeof SUPER_ADMIN_ROLES)[number];
